var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login pb-4"},[_c('div',{staticClass:"col-10 offset-1 col-md-6 offset-md-3 col-lg-4 offset-lg-4 rounded-10 pl-md-0 pr-md-0 background-white box-shadow d-flex mt-n5"},[_c('LoginComponent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }